import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { adminRoute } from '~/utils/routes/admin';

type DashboardLinkCardProps = {
  to: string;
  titleKey: string;
  descriptionKey: string;
};

const DashboardLinkCard = ({ to, titleKey, descriptionKey }: DashboardLinkCardProps) => {
  const { t } = useTranslation();

  return (
    <Link
      to={to}
      className='flex flex-col gap-1 rounded-lg border border-border bg-card p-4 transition-colors hover:border-primary sm:p-6'
    >
      <h2 className='text-base font-semibold text-foreground'>{t(titleKey)}</h2>
      <p className='text-sm text-muted-foreground'>{t(descriptionKey)}</p>
    </Link>
  );
};

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1 className='text-xl font-semibold text-foreground'>{t('pages.dashboard.title')}</h1>
      <p className='mt-1 text-sm text-muted-foreground'>{t('pages.dashboard.description')}</p>

      <div className='mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.funnel}`}
          titleKey='pages.funnel.title'
          descriptionKey='pages.funnel.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.protectMode}`}
          titleKey='pages.protectMode.title'
          descriptionKey='pages.protectMode.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.permissions}`}
          titleKey='pages.permissions.title'
          descriptionKey='pages.permissions.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.calls}`}
          titleKey='pages.calls.title'
          descriptionKey='pages.calls.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.location}`}
          titleKey='pages.location.title'
          descriptionKey='pages.location.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.safetyAlerts}`}
          titleKey='pages.safetyAlerts.title'
          descriptionKey='pages.safetyAlerts.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.errorLogs}`}
          titleKey='pages.errorLogs.title'
          descriptionKey='pages.errorLogs.description'
        />
        <DashboardLinkCard
          to={`${adminRoute.base}${adminRoute.supportRequests}`}
          titleKey='pages.supportRequests.title'
          descriptionKey='pages.supportRequests.description'
        />
      </div>
    </div>
  );
};

export default Dashboard;
